import { TranslationFunction } from '../../../common/types'
import { LivePricing } from '../../../hooks/combo-pricing'
import { FormattedLivePricingDataTransport } from '../../../models/pricing/live-pricing-formatter'
import { FormattedPropertyData } from '../../../models/property-details-page/property-details-model'

type Params = {
    selectedIndex: number
    isComboListing: boolean
    unitsData: FormattedPropertyData[]
    propertyDetails: FormattedPropertyData | null
    normalPricingDetails: FormattedLivePricingDataTransport | null
    isNormalPricingLoading: boolean
    normalPricingErrorCode: number | null
    comboPrices: Map<string, LivePricing>
    t: TranslationFunction
}

export const getUnitBasedProps = ({
    selectedIndex,
    isComboListing,
    unitsData,
    propertyDetails,
    normalPricingDetails,
    isNormalPricingLoading,
    normalPricingErrorCode,
    comboPrices,
    t,
}: Params) => {
    const selectedUnitData =
        selectedIndex !== -1 && unitsData && 0 <= selectedIndex && selectedIndex < unitsData.length
            ? unitsData[selectedIndex]
            : null

    const comboPriceData = selectedUnitData ? comboPrices.get(selectedUnitData.id) || null : null

    const pricingDetails = isComboListing ? comboPriceData?.pricingDetails || null : normalPricingDetails

    const isPricingLoading = isComboListing ? comboPriceData?.isLoading || false : isNormalPricingLoading

    const pricingErrorCode = isComboListing ? (comboPriceData?.error ?? null) : normalPricingErrorCode

    const bookingType = isComboListing ? selectedUnitData?.bookingType || null : propertyDetails?.bookingType || null

    const selectedUnitName = selectedIndex === -1 ? t('entitySection.title') : selectedUnitData?.title || ''

    const offers = isComboListing ? selectedUnitData?.offers || null : propertyDetails?.offers || null

    const showIncludedVatInformation = isComboListing
        ? selectedUnitData?.general.showIncludedVatInformation || false
        : propertyDetails?.general.showIncludedVatInformation || false

    const traumPaymentsActivated = isComboListing
        ? selectedUnitData?.general.traumPaymentsActivated || false
        : propertyDetails?.general.traumPaymentsActivated || false

    const showAvailabilityCalendar = isComboListing
        ? selectedUnitData?.general.showAvailabilityCalendar || false
        : propertyDetails?.general.showAvailabilityCalendar || false

    // In combo listings, user can select the the as per the maxPersion of entity
    const maxPersons = propertyDetails?.stats?.maxPersons

    return {
        pricingDetails,
        isPricingLoading,
        pricingErrorCode,
        bookingType,
        offers,
        showVatTax: showIncludedVatInformation,
        isTraumPaymentEnabled: traumPaymentsActivated,
        showCalendar: showAvailabilityCalendar,
        maxTotalGuests: maxPersons,
        selectedUnitName,
    }
}
